var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-row',[_c('v-img',{attrs:{"src":require("../../../assets/error404.avif"),"height":"500","width":"500"}})],1),_c('v-row',[_c('v-card-text',{staticClass:"text-center"},[_vm._v(" Resource not found... Please reload or contact admin ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }